import { ActionType } from '../constants/ActionTypes'

export default function promotionsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_PROMOTIONS_CATEGORIES_BEGIN:
            return {
                ...state,
                categories: [],
                loading: true,
                error: null
            }
        case ActionType.GET_PROMOTIONS_CATEGORIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case ActionType.GET_PROMOTIONS_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                categories: action.payload
            }
        case ActionType.SET_PROMOTIONS_KEY:
            return {
                ...state,
                promotionKey: action.payload
            }
        case ActionType.GET_PROMOTIONS_BEGIN:
            return {
                ...state,
                promotionsData: [],
                promotionsLoading: true,
                error: null
            }
        case ActionType.GET_LOAD_MORE_BEGIN:
            return {
                ...state,
                promotionsLoading: true,
                error: null
            }
        case ActionType.GET_LOAD_MORE_SUCCESS:
            return {
                ...state,
                promotionsLoading: false,
                promotionsData: {
                    ...state.promotionsData,
                    promotions: [
                        ...state.promotionsData.promotions,
                        ...action.payload.promotions
                    ]
                }
            }
        case ActionType.GET_PROMOTIONS_ERROR:
            return {
                ...state,
                promotionsLoading: false,
                error: action.payload
            }
        case ActionType.GET_HIGHLIGHT_PROMOTIONS_BEGIN:
            return {
                ...state,
                promotionsHighlightsData: [],
                promotionsHighlightsLoading: true,
            }
        case ActionType.GET_HIGHLIGHT_PROMOTIONS_ERROR:
            return {
                ...state,
                promotionsHighlightsLoading: false,
                error: action.payload
            }
        case ActionType.GET_HIGHLIGHT_PROMOTIONS_SUCCESS:
            return {
                ...state,
                promotionsHighlightsLoading: false,
                promotionsHighlightsData: action.payload
            }
        case ActionType.GET_PROMOTIONS_SUCCESS:
            return {
                ...state,
                promotionsLoading: false,
                promotionsData: action.payload
            }
        case ActionType.GET_PROMOTION_BEGIN:
            return {
                ...state,
                currentPromotion: {},
                error: null
            }
        case ActionType.GET_PROMOTION_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case ActionType.GET_PROMOTION_SUCCESS:
            return {
                ...state,
                currentPromotion: action.payload
            }
        case ActionType.GET_RANDOM_PROMOTIONS_BEGIN:
            return {
                ...state,
                randomPromotionsLoading: true,
             }
        case ActionType.GET_RANDOM_PROMOTIONS_ERROR:
            return {
                ...state,
                randomPromotionsLoading: false,
            }
        case ActionType.GET_RANDOM_PROMOTIONS_SUCCESS:
            return {
                ...state,
                randomPromotionsLoading: false,
                randomPromotions: action.payload
            }
        default:
            return state;
    }
}

